import React from "react";
import Select, { components } from "react-select";
import { CONSULTATION_TYPE_LIST } from "./constant";

const DropdownIndicator = (props) => {
  return (
    components.DropdownIndicator && (
      <components.DropdownIndicator {...props}>
        {props.selectProps.menuIsOpen ? (
          <i
            className="fa fa-caret-up"
            style={{ color: "#17bae0", padding: "0px 3px" }}
          ></i>
        ) : (
          <i
            className="fa fa-caret-down"
            style={{ color: "#17bae0", padding: "0px 3px" }}
          ></i>
        )}
      </components.DropdownIndicator>
    )
  );
};

const CustomeSelect = (props) => {
  const { consultation_type, handleConsultationType } = props;
  const styles = {
    control: (base) => ({
      ...base,
      width: "100%",
      background: " #F5F6F7 0% 0% no-repeat padding-box",
      boxShadow: "none",
      border: "none",
      cursor: "pointer",
      height: "20px",
      "&:hover": {
        boxShadow: "none",
      },
      "@media (max-width:768px)": {
        font: "normal normal normal 14px/17px Rubik",
      },
    }),
  };
  return (
    <div>
      <Select
        classNamePrefix="react-select"
        styles={styles}
        options={CONSULTATION_TYPE_LIST}
        components={{ DropdownIndicator: DropdownIndicator }}
        isSearchable={false}
        value={consultation_type}
        onChange={handleConsultationType}
      />
    </div>
  );
};

export default CustomeSelect;
